<template>
    <b-modal
        :id="modalId"
        title-tag="h2"
        :title="`Delete Estimate #${estimate.index}`"
        :lazy="true"
        ok-title="Proceed"
        @ok="proceedDelete()"
        footer-class="d-flex justify-content-between"
    >
        Are you sure you want to permanently delete this estimate?
    </b-modal>
</template>
<script type="text/javascript">
import BillingEstimateServices from "@/services/billing/billing-estimate.js";

export default {
    props: {
        modalId: {
            type: String,
            required: true
        },
        estimate: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    methods: {
        proceedDelete() {
            BillingEstimateServices.removeEstimate(this.estimate.id)
                .then(response => {
                    if (response.result.state == 0) {
                        this._message(response.message);
                        this.$emit("reload");
                    } else {
                        this._message(response.message, "danger");
                    }
                })
                .catch(error => {
                    this._message(
                        "Error : Unable to delete estimate",
                        "danger"
                    );
                    console.error(error);
                });
        }
    }
};
</script>
